import { Link } from "react-router-dom";
import { FaArrowRight, FaCompass, FaHome, FaMapMarkerAlt } from "react-icons/fa";

export default function NotFound() {
    return (
        <main className="relative isolate flex min-h-[78vh] items-center overflow-hidden bg-[#F8F7F4] px-5 pb-20 pt-28 text-[#061D33] sm:px-8 lg:pt-32">
            <div aria-hidden="true" className="pointer-events-none absolute -right-28 -top-28 h-96 w-96 rounded-full border border-[#D7C5A6]/50" />
            <div aria-hidden="true" className="pointer-events-none absolute -right-12 -top-12 h-72 w-72 rounded-full border border-[#D7C5A6]/50" />
            <div aria-hidden="true" className="pointer-events-none absolute bottom-0 left-0 h-48 w-48 rounded-full bg-[#E9B84F]/10 blur-3xl" />

            <div className="relative mx-auto grid w-full max-w-[1120px] items-center gap-12 lg:grid-cols-[1.05fr_0.95fr] lg:gap-20">
                <section className="order-2 text-center lg:order-1 lg:text-left">
                    <div className="inline-flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.24em] text-[#A68142]">
                        <span className="h-px w-8 bg-[#A68142]" /> A little detour
                    </div>
                    <h1 className="mt-6 font-serif text-[43px] font-normal leading-[1.08] tracking-tight text-[#061D33] sm:text-[58px] lg:text-[67px]">
                        This page is <span className="italic text-[#A68142]">off the map.</span>
                    </h1>
                    <p className="mx-auto mt-6 max-w-lg text-sm leading-8 text-[#6C7989] lg:mx-0 sm:text-base">
                        The link you followed may have changed or the page may no longer be available. Your next great stay is still just a click away.
                    </p>
                    <div className="mt-9 flex flex-wrap items-center justify-center gap-3 lg:justify-start">
                        <Link to="/" className="inline-flex min-h-12 items-center justify-center gap-3 bg-[#061D33] px-7 py-3.5 text-xs font-bold text-white transition-colors hover:bg-[#153B59]">
                            <FaHome size={13} /> Back to homepage <FaArrowRight size={11} />
                        </Link>
                        <Link to="/hotels" className="inline-flex min-h-12 items-center justify-center gap-3 border border-[#D5C7B2] bg-white px-7 py-3.5 text-xs font-bold text-[#061D33] transition-colors hover:border-[#A68142] hover:bg-[#F2ECE1]">
                            Explore hotels <FaArrowRight size={11} />
                        </Link>
                    </div>
                    <div className="mt-10 flex items-center justify-center gap-2 border-t border-[#E3DED5] pt-6 text-xs text-[#7A8491] lg:justify-start">
                        <FaMapMarkerAlt className="text-[#A68142]" /> Discover your next stay in Dubai
                    </div>
                </section>

                <div className="order-1 flex justify-center lg:order-2">
                    <div className="relative flex aspect-square w-full max-w-[410px] items-center justify-center overflow-hidden rounded-full border border-[#DAD0BF] bg-[#F1EDE5]">
                        <div className="absolute inset-[10%] rounded-full border border-dashed border-[#C5B392]" />
                        <div className="absolute inset-[22%] rounded-full border border-[#DAD0BF]" />
                        <FaCompass aria-hidden="true" className="absolute right-[16%] top-[20%] text-2xl text-[#A68142]/60" />
                        <div className="relative text-center">
                            <div className="font-serif text-[115px] leading-none tracking-[-0.08em] text-[#061D33] sm:text-[145px]">404</div>
                            <div className="mx-auto mt-3 h-px w-24 bg-[#A68142]" />
                            <p className="mt-4 text-[10px] font-bold uppercase tracking-[0.32em] text-[#A68142]">Page not found</p>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}
